import { PrivacyPolicyLocalization } from '../interfaces/privacyPolicyDocument';

/**
 * Pick the localization to show for a language.
 *
 * The backend returns one entry per culture code (`en-US`, `nl-NL`, ...) while
 * i18next works with a plain language (`en`, `nl`, `de`), so the match is made
 * on the language part of the culture code and is case insensitive. When
 * nothing matches, the first entry is used: a policy in the wrong language is
 * still better than a dead link.
 * @param localizations The localizations of the document
 * @param language The active i18next language
 * @returns
 */
const pickLocalization = (
	localizations: PrivacyPolicyLocalization[],
	language: string
): PrivacyPolicyLocalization | undefined => {
	const languageCode = language.split('-')[0].toLowerCase();

	return (
		localizations.find(
			(localization) => localization.cultureCode.split('-')[0].toLowerCase() === languageCode
		) ?? localizations[0]
	);
};

export default pickLocalization;
